import { useRouter } from "next/router";
import { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { postOrder, SettlementAPI } from "../../../api/order";
import { failAlert, successAlert } from "../../../common/alert";
import { cancelOrderConfirm } from "../../../common/confirm";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../../redux/action/confirm";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import ConfirmModal from "../../elements/ConfirmModal";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    position: fixed;
    top: 30vh;
    left: 37vw;
    width: 26vw;
    height: 40vh;
    background-color: white;
    border-radius: 20px;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: 1201px) and (max-width: 1600px) {
      left: 35vw;
      width: 30vw;
    }

    @media only screen and (min-width: 992px) and (max-width: 1200px) {
      left: 35vw;
      width: 30vw;
    }

    @media only screen and (min-width: 768px) and (max-width: 991px) {
      left: 30vw;
      width: 40vw;
    }

    @media only screen and (min-width: 576px) and (max-width: 767px) {
      left: 23vw;
      width: 54vw;
    }

    @media only screen and (max-width: 575px) {
      left: 5vw;
      width: 90vw;
    }

    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .modal-header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #253d4e;

    @media only screen and (max-width: 575px) {
      font-size: 1rem;
    }

    & i {
      font-size: 15px;
      color: #253d4e;
      border: 2px solid #253d4e;
      border-radius: 50%;
      padding: 5px;
      cursor: pointer;
      margin-right: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      width: 30px;
      :hover {
        color: #3bb77e;
        border: 2px solid #3bb77e;
      }

      @media only screen and (max-width: 575px) {
        font-size: 12px;
      }
    }
  }

  .modal-content {
    width: 100%;
    /* height: calc(70vh - 63px); */
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    & > span {
      color: black;
    }

    .content-header {
      padding-bottom: 1rem;

      .header {
        color: #253d4e;
        font-size: 15px;
        font-weight: 500;

        @media only screen and (max-width: 575px) {
          font-size: 14px;
        }
      }
    }

    .content {
      textarea {
        min-height: 10rem !important;
        color: #253d4e;
        font-size: 15px;
        font-weight: 500;
      }
    }
  }

  .modal-footer {
    button {
      font-size: 15px;
      font-weight: 500;

      @media only screen and (max-width: 575px) {
        font-size: 14px;
      }
    }
  }
`;

const OrderCancelModal = ({
  orderNum,
  onClickOrderCancelModal,
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
  isLoaded,
  isLoading,
  division,
}) => {
  const router = useRouter();
  const [reason, setReason] = useState("");

  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return onClickOrderCancelModal();
  };

  // 취소 사유
  const onChangeCancelReason = (e) => {
    setReason(e.target.value);
  };

  // 주문 취소 action handler
  const executeActionHandler = async () => {
    isLoading();
    const body = {
      modes: "Cancel",
      division: division,
      ordernum: orderNum,
      msg: reason,
    };

    const res = await SettlementAPI(body);

    if (res?.Code === "0000") {
      isLoaded();
      successAlert("주문 취소가 완료되었습니다.");
      closeConfirmModal();
      onClickOrderCancelModal();
      // 채널톡 주문 취소 이벤트
      window.ChannelIO("track", "Cancel");
      return router.reload(router.asPath);
    } else {
      isLoaded();
      alert(res?.Data?.Msg);
      closeConfirmModal();
    }
  };

  // 취소 사유 제출
  const onSumbitHandler = async () => {
    if (reason === "") {
      return failAlert("취소 사유를 작성해주세요.");
    }

    modifyConfirmModal(cancelOrderConfirm(executeActionHandler));
    return openConfirmModal();
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="modal-header">
            주문 취소
            <i className="fi-rs-cross" onClick={onClickOrderCancelModal} />
          </div>
          <div className="modal-content">
            <div className="content-header">
              <p className="header">
                주문 취소 사유를 입력해주세요. ( 최대 100자 )
              </p>
            </div>
            <div className="content">
              <textarea
                onChange={onChangeCancelReason}
                maxLength={100}
              ></textarea>
            </div>
            <div></div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-sm" onClick={onSumbitHandler}>
              완료
            </button>
          </div>
        </div>
      </ModalWrapper>
      <ConfirmModal />
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
});

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderCancelModal);
